import {applyMiddleware} from 'redux';
import thunk from 'redux-thunk';

import {events} from 'src/shared/events/middleware';
import {compose} from 'src/shared/utils/compose';

import {logger} from './logger';
import {channelTracking} from 'src/pages/localChannelLineup/store/enhancers/channelTracking';

export const enhancers = compose(
  applyMiddleware(
    thunk,
    logger,
    channelTracking,
    events
  )
);
